import { digitDateWithDigitHourFormatter } from "../../components/tools";

export const CancelledFormatter = (item) => {
  const { status_history, created_at } = item;

  const array = [
    {
      date: digitDateWithDigitHourFormatter(created_at),
      text: "You created a transaction",
      isActive: true,
    },
    {
      date: digitDateWithDigitHourFormatter(
        (status_history || [])[0]?.created_at
      ),
      text: "We were unable to process your transaction. Please ask your account manager for more info",
      isRedButton: true,
      isActive: true,
    },
  ];

  return array;
};
